import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CommonService } from '../../../../shared/common.service';
import { TurnoverComponentService } from './service/turnover-component.service';
import * as CryptoJS from 'crypto-js';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
import { Observable } from 'rxjs';
import { IncomeStatementService } from '../../income-statement/income-statement.service';

@Component({
  selector: 'app-turnover',
  templateUrl: './turnover.component.html',
  styleUrls: ['./turnover.component.scss']
})
export class TurnoverComponent implements OnInit {
  Turnoverrevenue: FormGroup;
  showBubbledata: any;
  isJump: any; disableTurnover: boolean; turnovergriddata: any; valid: boolean = true; isCloseAccounts: boolean; NormalRoutng: boolean;
  constructor(private Formbuilder: FormBuilder, private turnoverservice: TurnoverComponentService, private incomeStatementService: IncomeStatementService, public commonService: CommonService, private router: Router, private sidenav: SideNavService) {

  }
  ngOnInit() {
   // this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.getIncomeStatementData()
    this.commonService.getIncomeStatementsHeaders();
    this.createformgroup();
    if (this.wizardrowslist.length > 0) {
      if (this.Turnoverrevenue.get('Wizardrows')['controls'][0].controls['ItemDescription'].value == null)
        this.wizardrowslist.removeAt(0);
    }
    this.Getdata();
    this.clearfield();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.Getdata_LY()
      }
    })
    this.isJump = localStorage.getItem('isJump');
   

  }
  IncomeTurnoverRevenue:any
  getIncomeStatementData() {
    debugger
    var APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.incomeStatementService.getIncomeStatement(APPeriodId).subscribe((data1) => {
      this.IncomeTurnoverRevenue = data1;
    })
  }
  createformgroup() {
    this.Turnoverrevenue = this.Formbuilder.group({ 
      Details_ID: new FormControl(),
      Turnover_revenue_Id: new FormControl(),
      Master_ID: new FormControl(),
      Total: new FormControl({ disabled: true, value: '' }),
      Total_LY: new FormControl({ disabled: true, value: '' }),
      TurnoverRevenueFreeøtextComment: new FormControl(),
      APPeriodId: new FormControl(),
      Wizardrows: this.Formbuilder.array([this.Formbuilder.group({
        ItemDescription: new FormControl(),
        Turnover_revenue_Id: new FormControl(),
        Total: new FormControl(),
        Total_LY: new FormControl(),
        Details_ID: new FormControl(),
      })])
    });
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.Turnoverrevenue.reset();
        debugger;
        this.Turnoverrevenue.reset();
        this.wizardrowslist.clear();
        this.Turnoverrevenue.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
      }
    })
  }

  validations(from?:any) {
    debugger;
    //for (var i = 0; i < this.Turnoverrevenue.value.Wizardrows.length; i++) {
    //  if ((this.wizardrowslist.length > 0) && (this.Turnoverrevenue.value.Wizardrows[i].ItemDescription == null || this.Turnoverrevenue.value.Wizardrows[i].ItemDescription == "")) {
    //    Swal.fire("Andica Accounts Production", 'Item description must be completed.');
    //    return true;
    //  }
    //  //if ((this.wizardrowslist.length > 0) && (this.Turnoverrevenue.value.Wizardrows[i].Turnover_revenue_Id == null || this.Turnoverrevenue.value.Wizardrows[i].Turnover_revenue_Id == "")) {
    //  //  Swal.fire('', 'Share class type must be completed.');
    //  //  return true;
    //  //}
    //}

    if (this.wizardrowslist.length == 0)
      this.valid = true;
    if (this.wizardrowslist.length) {
      var data = [];
      for (var j = 0; j < this.wizardrowslist.length; j++) {
        var v = this.Turnoverrevenue.value.Wizardrows.filter(x => x.ItemDescription == this.wizardrowslist.value[j].ItemDescription)
        if (v.length > 1) {
          data = v;
          Swal.fire("Andica Accounts Production", "Item Description is already present.", 'warning');
          return false;
        }
      }
    }
    for (var i = 0; i < this.Turnoverrevenue.value.Wizardrows.length; i++) {
      if ((this.Turnoverrevenue.value.Wizardrows.length > 0) && (this.Turnoverrevenue.value.Wizardrows[i].ItemDescription == null || this.Turnoverrevenue.value.Wizardrows[i].ItemDescription == "")) {
        //Swal.fire("Andica Accounts Production", 'Item description must be completed.', 'warning');
        this.valid = false;
        return false;
      }
      else {
        this.valid = true;
      }
    }
    if (this.commonService.AccountTemplateId == 11 && from == 'save') {
      if (+this.Turnoverrevenue.controls['Total'].value != +this.IncomeTurnoverRevenue.TurnoverRevenue) {
        Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.StartYear + ".", 'warning');
        return false;
      }
      else if (+this.Turnoverrevenue.controls['Total_LY'].value != +this.IncomeTurnoverRevenue.TurnoverRevenue_LY) {
        Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.LastYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.LastYear + ".", 'warning');
        return false;
      }
      else
        return true
    }
    return true;
  }
  Addnewrow() {
    debugger;
    if (this.validations()) {
      this.wizardrowslist.push(this.Formbuilder.group({ Details_ID: null, ItemDescription: '', Total: '', Total_LY: '', Turnover_revenue_Id: null }));
    }
    else {
      
    }
  }
  total: any = 0;
  total1: any = 0;
  Index: any;
  Autocalculation1(index) {
    debugger;
    this.Index = index;
    this.total = 0;
    if (this.Turnoverrevenue.value.Wizardrows[index].Total != null || this.Turnoverrevenue.value.Wizardrows[index].Total != "") {
      if (this.Turnoverrevenue.value.Wizardrows[index].Total == "") {
        this.Turnoverrevenue.value.Wizardrows[index].Total = 0;
      }
      for (var i = 0; i < this.Turnoverrevenue.value.Wizardrows.length; i++) {
        var data = (parseFloat(this.Turnoverrevenue.value.Wizardrows[i].Total));
        this.total = +this.total + data;
        this.Turnoverrevenue.controls['Total'].setValue(this.total);
      }
    }
  }
  Autocalculation2(index) {
    this.total1 = 0;
    if (this.Turnoverrevenue.value.Wizardrows[index].Total_LY != null || this.Turnoverrevenue.value.Wizardrows[index].Total_LY != "") {
      if (this.Turnoverrevenue.value.Wizardrows[index].Total_LY == "") {
        this.Turnoverrevenue.value.Wizardrows[index].Total_LY = 0;
      }
      for (var i = 0; i < this.Turnoverrevenue.value.Wizardrows.length; i++) {
        var data = (parseFloat(this.Turnoverrevenue.value.Wizardrows[i].Total_LY));
        this.total1 = +this.total1 + data;
        this.Turnoverrevenue.controls['Total_LY'].setValue(this.total1);
      }
    }
  }


  CalculationsGrid() {
    debugger;
    this.total = 0;
    this.total1 = 0;
    this.total =this.Turnoverrevenue.value.Wizardrows.reduce((a, b) => a += +b.Total,0)
    this.total1 = this.Turnoverrevenue.value.Wizardrows.reduce((a, b) => a += +b.Total_LY,0)
    // this.CreateTaxationFormGroup.value.CreateTaxationFormGroupGrid

    this.Turnoverrevenue.controls['Total'].setValue(this.total);
    this.Turnoverrevenue.controls['Total_LY'].setValue(this.total1);

  }

  get wizardrowslist() {
    return this.Turnoverrevenue.get('Wizardrows') as FormArray;
  }
  isdelete: boolean = true;
  //savegriddetails() {
  //  if (this.Turnoverrevenuedata.Turnover_revenue_Id) {
  //    this.Turnoverrevenue.value.Wizardrows.filter(x => x.Turnover_revenue_Id = this.Turnoverrevenuedata.Turnover_revenue_Id);
  //    var data = this.Turnoverrevenue.value.Wizardrows;
  //    if (data.length >= 0) {
  //      this.turnoverservice.insertgriddetails(this.Turnoverrevenuedata.Turnover_revenue_Id, data).subscribe((data: any) => {
  //        var nextPage;
  //        nextPage = this.commonService.getNextNoteSelection("Turnover / revenue", this.commonService.NotesList)
  //        if (!this.isCloseAccounts) {
  //          if (this.isJump == 'true')
  //            this.router.navigate(['/notes'])
  //          else if (nextPage == 'Turnover/revenue') {
  //            nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
  //            this.router.navigate([nextPage]);
  //          }
  //          else {
  //            this.router.navigate([nextPage]);
  //          }
  //        }
  //      })
  //    }
  //  }
  //  else
  //    return;
  //}
  back() {
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Turnover / revenue", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }
  savebtn: boolean = false;
  Save() {//this.savebtn = true;
    //this.isdelete = false;
      if (this.validations('save')) {
        var data = this.Turnoverrevenue.getRawValue();
        let id = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
        data.APPeriodId = id;
        this.turnoverservice.insertdetails(data).subscribe((data: any) => {
          this.Turnoverrevenue.markAsPristine();
          if (this.NormalRoutng)
            return true;
          var nextPage;
          nextPage = this.commonService.getNextNoteSelection("Turnover / revenue", this.commonService.NotesList)
          if (this.isJump == 'true')
            this.router.navigate(['/notes'])
          else if (nextPage == 'turnover/revenue') {
            nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
            this.router.navigate([nextPage]);
          }
          else {
            this.router.navigate([nextPage]);
          }
        })
      }

      else {
        this.NormalRoutng = false;
        return false;
      }
    }
  deletegridDetails(index: number) {
    Swal.fire({
      titleText: "Andica Accounts Production",
      text: 'Are you sure you want to delete?',
      icon: "question",
      showCancelButton: true,
      confirmButtonText: 'Yes', 
      cancelButtonText: 'No',
      allowOutsideClick: false
    }).then((result) => {
      if (result.value) {
        this.wizardrowslist.removeAt(index);
        this.CalculationsGrid();
      } else if (result.dismiss === Swal.DismissReason.cancel) {

      }
    })
  }
  Turnoverrevenuedata: any;
  Turnoverid: any;
  Getdata() {
    let id = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.turnoverservice.getdata(id).subscribe((data: any) => {
      this.Turnoverrevenue.patchValue(data);
      if (data.Total == null) {
        this.Turnoverrevenue.controls['Total'].setValue(0);
      }
      if (data.Total_LY == null) {
        this.Turnoverrevenue.controls['Total_LY'].setValue(0);
      }
      this.Turnoverrevenuedata = data;
      this.Turnoverid = this.Turnoverrevenuedata.Turnover_revenue_Id;
      if (this.savebtn) {
        //this.savegriddetails();
        this.savebtn = false;
      }
      this.Getgriddata();
    })
    this.commonService.getNotesData()
    return false;
  }
  Getgriddata() {
    debugger;
    this.turnoverservice.getgriddata(this.Turnoverid).subscribe((data: any) => {
      this.turnovergriddata = data;
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          this.wizardrowslist.push(this.Formbuilder.group({
            Details_ID: data[i].Details_ID, ItemDescription: data[i].ItemDescription,
            Total: data[i].Total ? data[i].Total:0, Total_LY: data[i].Total_LY? data[i].Total_LY:0, Turnover_revenue_Id: data[i].Turnover_revenue_Id
          }));
        }
      }
      if (localStorage.getItem("SubmitStatus") == "true") {
        this.Turnoverrevenue.disable();
        this.Turnoverrevenue.controls['Wizardrows'].disable();
        this.disableTurnover = true;
        this.Turnoverrevenue.controls['TurnoverRevenueFreeøtextComment'].disable()
      }
    })
  }

  Getdata_LY() {
    debugger;
    let id = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.turnoverservice.getdata_LY(id).subscribe((data: any) => {
      debugger;
      this.showBubbledata = data;
    })
    this.commonService.getNotesData()
  }


  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.Turnoverrevenue.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight:900'>You have unsaved data. </span><br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.Save())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }
  
  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);
  }
}
